import type { FormInputData } from "../../BuildingBlocks/Forms/Controllers/FormFieldController";

export interface MaStRGeneratorFormValues {
  mastrNummer: string;
  person: number | null;
}

export const MASTR_GENERATOR_FORM_FIELD_DATA = {
  mastrNummer: {
    name: "mastrNummer",
    label: "Marktstammdatenregister-Nummer einer Einheit oder Anlage",
    type: "text",
    required: true,
    helpText:
      "Die Marktstammdatenregisternummer ist eine 15-stellige Zeichenkette mit festgelegtem Präfix.\n\n" +
      "Beispiele:\n\n" +
      "- Stromerzeugungseinheit: SEE920202020203\n" +
      "- EEG-Anlage: EEG987654321012\n" +
      "- KWK-Anlage: KWK987654321012\n\n" +
      "Erlaubte Präfixe: SEE, SME, EEG und KWK"
  },
  person: {
    name: "person",
    label: "Betreiber",
    type: "select",
    required: true,
    helpText: "Betreiber der importierten Stromerzeugungseinheiten",
    data: [] // will be set at runtime
  }
} as const satisfies {
  [key in keyof MaStRGeneratorFormValues]: FormInputData<
    MaStRGeneratorFormValues,
    key
  >;
};

export const MASTR_GENERATOR_DEFAULT_VALUES: MaStRGeneratorFormValues = {
  mastrNummer: "",
  person: null
};
